module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv9-da34421f51bef5a645dae510962464b4.jpg";